const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const calculateBaseValues = (
  detectedMeterType,
  usageType,
  capturedDayValue,
  capturedNightValue,
  usageValue,
) => {
  let baseValue = 0;
  let secondBaseValue = 0;

  if (
    (detectedMeterType === "Day/Night" ||
      detectedMeterType === "Peak/Off-Peak") &&
    usageType === "kwh"
  ) {
    baseValue = Number.parseInt(capturedDayValue) || 0;
    secondBaseValue = Number.parseInt(capturedNightValue) || 0;
  } else {
    baseValue = Number.parseInt(usageValue) || 0;
  }

  return { baseValue, secondBaseValue };
};

export const calculateAnnualConsumption = (
  baseValue,
  secondBaseValue,
  usagePeriod,
) => {
  const multipliers = {
    Month: 12,
    Quarter: 4,
    "6Months": 2,
    "12Months": 1,
  };

  const multiplier = multipliers[usagePeriod] || 1;

  return {
    annualConsumption: baseValue * multiplier,
    consumptionNightRate: secondBaseValue * multiplier,
  };
};

export const getMpanDetails = (
  showManualAddress,
  manualAddress,
  mpan,
  selectedAddressData,
) => {
  if (showManualAddress) {
    return {
      mpanCore: manualAddress?.mpanCore?.slice(8, 21),
      profileClass: manualAddress?.mpanCore?.substring(0, 2),
      lineLossFactor: manualAddress?.mpanCore?.substring(5, 8),
      meterPointSwitchCode: manualAddress?.mpanCore?.substring(2, 5),
    };
  }

  return {
    mpanCore: mpan,
    profileClass: selectedAddressData?.profileClassId,
    lineLossFactor: selectedAddressData?.lineLossFactorClassId,
    meterPointSwitchCode: selectedAddressData?.meterTimeswitchCode,
  };
};

export const getStartDateISO = (selectedDate) => {
  return new Date(
    selectedDate.year,
    MONTH_NAMES.indexOf(selectedDate.month),
    selectedDate.day,
  ).toISOString();
};

export const buildElectricityQuoteData = ({
  mpanDetails,
  showManualAddress,
  usageType,
  detectedMeterType,
  singleRateBilling,
  annualConsumption,
  consumptionNightRate,
  selectedDate,
  selectedAddressData,
}) => {
  const isTwoRateMeter =
    detectedMeterType === "Day/Night" || detectedMeterType === "Peak/Off-Peak";

  return {
    profileClass: mpanDetails.profileClass,
    meterPointSwitchCode: mpanDetails.meterPointSwitchCode,
    lineLossFactor: mpanDetails.lineLossFactor,
    mpanCore: mpanDetails.mpanCore,
    manualAddress: showManualAddress,
    consumptionType: usageType === "kwh" ? 1 : 2,
    twoRateMeter: isTwoRateMeter,
    singleRateBilling: singleRateBilling,
    annualConsumption: annualConsumption,
    consumptionNightRate: isTwoRateMeter ? consumptionNightRate : 0,
    startDate: getStartDateISO(selectedDate),
    mpanEncrypted: showManualAddress
      ? null
      : selectedAddressData?.mpanEncrypted,
    annualConsumptionSpend: annualConsumption,
    isPrePayment: detectedMeterType === "prepayment",
    meterType: detectedMeterType,
  };
};

export const buildGasQuoteData = ({
  annualConsumption,
  usageType,
  selectedAddressData,
  meterType,
  showManualAddress,
  detectedMeterType,
  mprn,
  postcode,
  selectedDate,
}) => {
  return {
    twoRateMeter: false,
    annualConsumption: annualConsumption,
    annualConsumptionSpend: annualConsumption,
    consumptionType: usageType === "kwh" ? 1 : 2,
    designation: selectedAddressData?.designation,
    isPrePayment: meterType === "prepayment",
    manualAddress: showManualAddress,
    meterType: detectedMeterType,
    mprnCore: mprn,
    mprnEncrypted: selectedAddressData?.mprnEncrypted,
    postCode: postcode,
    startDate: getStartDateISO(selectedDate),
  };
};

export const buildFormData = ({
  selectedFuel,
  postcode,
  showManualAddress,
  manualAddress,
  selectedDate,
  usageType,
  usageValue,
  usagePeriod,
  mpan,
  mprn,
  selectedAddress,
  detectedMeterType,
  selectedAddressData,
  singleRateBilling,
  meterType,
  addressData,
  dayOrPeakValue,
  nightOrOffPeakValue,
}) => {
  return {
    selectedFuel,
    postcode,
    showManualAddress,
    manualAddress,
    selectedDate,
    usageType,
    usageValue,
    usagePeriod,
    mpan,
    mprn,
    selectedAddress,
    detectedMeterType,
    selectedAddressData,
    singleRateBilling,
    meterType,
    addressData,
    dayOrPeakValue,
    nightOrOffPeakValue,
  };
};

export const validateMeterSelection = (
  showManualAddress,
  selectedAddress,
  selectedFuel,
) => {
  if (!showManualAddress && !selectedAddress) {
    const errorMessage =
      selectedFuel === "electricity"
        ? "Please select the electricity Meter Point Administration Number (MPAN) associated to your business site address"
        : "Please select the gas Meter Point Reference Number (MPRN) associated to your business site address";
    return { isValid: false, error: errorMessage };
  }
  return { isValid: true, error: "" };
};

export const getQuoteEndpoint = (selectedFuel) => {
  return selectedFuel === "electricity"
    ? "/api/v1/quote/electricquote"
    : "/api/v1/quote/gasquote";
};
